import { Link } from 'react-router-dom';

interface BreadcrumbLink {
    label: string;
    to: string;
    isCurrentPage: boolean;
}

interface BreadCrumbProps {
    links: BreadcrumbLink[];
}

const BreadCrumb: React.FC<BreadCrumbProps> = ({ links }) => {
    return (
        <nav className="flex" aria-label="Breadcrumb">
            <ol className="inline-flex items-center space-x-1 md:space-x-2 rtl:space-x-reverse">
                {links.map((link, index) => (
                    <li key={index} className="inline-flex items-center">
                        {link.isCurrentPage ? (
                            <span className="text-sm font-medium text-gray-500 dark:text-gray-400">{link.label}</span>
                        ) : (
                            <>
                                <Link
                                    to={link.to}
                                    className="text-sm font-medium text-gray-700 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white"
                                >
                                    {link.label}
                                </Link>
                                {index == 0 && (
                                    <svg
                                        className="rtl:rotate-180 w-3 h-3 text-gray-400 mx-1"
                                        aria-hidden="true"
                                        xmlns="http://www.w3.org/2000/svg"
                                        fill="none"
                                        viewBox="0 0 6 10"
                                    >
                                        <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m1 9 4-4-4-4" />
                                    </svg>
                                )}
                            </>
                        )}
                    </li>
                ))}
            </ol>
        </nav>
    );
};

export default BreadCrumb;
